module.exports = __webpack_public_path__ + "static/media/E_SDG_Icons-16.c79169ca.jpg";